import { FileExtendedDetails } from 'sos-common/js/commonTypes';

export enum Document {
  KvittensForBetalning = 'doc_kvittens',
  PersonbevisEllerPass = 'doc_personbevis',
  Sprakintyg = 'doc_sprakintyg',
  Examensbevis = 'doc_examensbevis',
  IntygAktuellBehorighet = 'doc_intygaktuellbehorighet',
  IntygNamnbyte = 'doc_intygnamnbyte',
  Kursbeskrivning = 'doc_kursbeskrivning',
  Artikel_11 = 'doc_artikel_11',
  Artikel_44_23 = 'doc_artikel_44_23',
  Artikel_43_43a_40_41_23 = 'doc_artikel_43_43a_40_41_23',
  Artikel_24_23 = 'doc_artikel_24_23',
  Artikel_31_33_33a_23 = 'doc_artikel_31_33_33a_23',
  Artikel_34_37_23 = 'doc_artikel_34_37_23',
  Artikel_3_dot_3 = 'doc_artikel_3_dot_3',
  Artikel_25_28_allmanmedicin_23 = 'doc_artikel_25_28_allmanmedicin_23',
  Artikel_25_28_allmanmedicin_23_forsta = 'doc_artikel_25_28_allmanmedicin_23_forsta',
  Artikel_25_28_allmanmedicin_23_andra = 'doc_artikel_25_28_allmanmedicin_23_andra',
  Artikel_11_23 = 'doc_artikel_11_23',
  Artikel_35_23 = 'doc_artikel_35_23',
  DokumentFranUtbildning = 'doc_dokumentfranutbildning',
  KopiaSpecialistutbildning = 'doc_kopiaspecialistutbildning',
  KopiaForstaSpecialistutbildning = 'doc_kopiaforstaspecialistutbildning',
  KopiaAndraSpecialistutbildning = 'doc_kopiaandraspecialistutbildning',
  KopiaSpecialistkompetensbevis = 'doc_kopiaspecialistkompetensbevis',
  KopiaForstaSpecialistkompetensbevis = 'doc_kopiaforstaspecialistkompetensbevis',
  KopiaAndraSpecialistkompetensbevis = 'doc_kopiaandraspecialistkompetensbevis',
  Tjanstgoringsintyg = 'doc_tjanstgoringsintyg',
  AndraIntyg = 'doc_andraintyg',
  Kursplan = 'doc_kursplan',
  DiplomaSupplement = 'doc_diplomasupplement',
  Gymnasiebetyg = 'doc_gymnasiebetyg',
  PraktiskTjanstgoring = 'doc_praktisktjanstgoring',
  SvenskaForfattningar = 'doc_svenskaforfattningar',
  Ovrigt = 'doc_ovrigt',
}

export interface DocumentModel {
  title: string;
  infobubble?: string;
  isRequired: boolean;
  fieldName: string;
  order: number;
  files: FileExtendedDetails[];
}

// IMPORTANT!!
// The order of this list MATTERS! It will determine the order weight of the documents.
// In the UI when we render the fileupload components, the order in which they appear
// on the webpage is directly linked to the order of this list.
export const DOCUMENT_LIST = [
  Document.KvittensForBetalning,
  Document.PersonbevisEllerPass,
  Document.IntygNamnbyte,
  Document.KopiaSpecialistkompetensbevis,
  Document.KopiaForstaSpecialistutbildning,
  Document.KopiaForstaSpecialistkompetensbevis,
  Document.KopiaAndraSpecialistutbildning,
  Document.KopiaAndraSpecialistkompetensbevis,
  Document.KopiaSpecialistutbildning,
  Document.IntygAktuellBehorighet,
  Document.Artikel_11,
  Document.Artikel_44_23,
  Document.Artikel_43_43a_40_41_23,
  Document.Artikel_24_23,
  Document.Artikel_31_33_33a_23,
  Document.Artikel_34_37_23,
  Document.Artikel_3_dot_3,
  Document.Artikel_25_28_allmanmedicin_23,
  Document.Artikel_25_28_allmanmedicin_23_forsta,
  Document.Artikel_25_28_allmanmedicin_23_andra,
  Document.Artikel_11_23,
  Document.Artikel_35_23,
  Document.Sprakintyg,
  Document.Examensbevis,
  Document.DokumentFranUtbildning,
  Document.Tjanstgoringsintyg,
  Document.Kursbeskrivning,
  Document.Kursplan,
  Document.DiplomaSupplement,
  Document.Gymnasiebetyg,
  Document.PraktiskTjanstgoring,
  Document.SvenskaForfattningar,
  Document.Ovrigt,
];

export const DOCUMENT_LIST_SKYDDAD_YRKESTITEL = [
  Document.KvittensForBetalning,
  Document.PersonbevisEllerPass,
  Document.DokumentFranUtbildning,
  Document.Kursbeskrivning,
  Document.Sprakintyg,
  Document.IntygAktuellBehorighet,
  Document.IntygNamnbyte,
  Document.AndraIntyg,
];
